import React from 'react';

const SVG = ({
  fill = '#fff',
  width = '100%',
  height = '100%',
  className = 'sphinxSVG',
}) => (
  <svg
    viewBox="0 0 288 267.5"
    height={height}
    width={width}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M218.3,131.3c0,0,0.3,1.7,1.7,3.1c1.5,1.6,3.4,3,5.5,2.4c2.1-0.6,4.5,0.1,4.5,0.1l-2.4,1.2c0,0-2.8,2.4-4.9,2.5
	c-2.1,0.1-4.8-0.7-5.8-2c-1-1.3-0.5-3.2-0.3-3.7C216.9,134.2,218.3,131.3,218.3,131.3z"
    />
    <path
      d="M232,126.6c-0.6-1.4-3.8-7.9-5.3-10.1s-10.5-18.8-11.3-21.4c-0.8-2.6-0.8-12.8-1.5-15.4c-0.8-2.6-3-6-4.5-8.3
	c-1.5-2.3-5.6-19.9-5.6-19.9s-1.9-3.8-4.5-4.5c-2.6-0.8-7.5,0-9.8,0c-2.3,0-15.8,4.9-17.6,4.9c-1.9,0-5.6,5.3-5.6,8.3
	s-4.1,11.6-5.6,14.6c-1.5,3-17.6,4.9-19.9,6.2c-2.3,1.3-12,1.3-15.4,0.6c-3.4-0.8-12.4-0.8-14.6,0c-2.3,0.8-6.8,2.3-9.8,4.1
	s-25.5,19.9-27.1,21.4s-6.7,7.5-6.7,10.5s3.8,5.3,6.7,6.4c2.9,1.1,3.5,4.9,4.2,6.8c0.8,1.9,10.5,6,12.4,7.4
	c1.9,1.4,3.8,9.5,3.8,12.9s-4.1,15.4-6,19.1c-1.9,3.8-13.1,25.2-13.1,25.2l-11.6,16.1l-9.8,13.9c0,0-0.4,2.3,0,7.5
	c0,0,8.3,7.9,10.1,10.9s1.9,16.9,1.9,16.9s1.9,2.1,3.6,2.6c1.7,0.6,11.3,1.1,12.6,1.1c1.3,0,10.7,1.7,13.3,2.3s12.8-0.8,15-1.5
	c2.3-0.8,15.8-1.1,17.3-1.7c1.5-0.6,4.3-2.4,5.4-4.1c1.1-1.7,0.6-5.4,0.6-7.7c0-2.3,2.1-7.1,3.2-9.6c1.1-2.4,6.8-8.8,9-10.3
	c2.3-1.5,10.3-19,11.6-22.1c1.3-3.2,6.4-10.7,8.3-12.4c1.9-1.7,5.3-9.2,6.9-10.3c1.7-1.1,2.4-1.1,4.5-1.5c2.1-0.4,9.2,1.2,10.7,1.5
	c1.7,0.3,10.3,1.5,10.3,1.5s7,1.6,12.8,0.8c5.7-0.8,8.6-5.4,9.4-7.1c0.8-1.7,1.5-5.8,1.5-7.3c0-1.5-1.3-6-1.7-7.3
	c-0.4-1.3,0-2.6,1.1-3.6c1.1-0.9,2-1.3,3.3-2c1.3-0.7,1.5-2,1.1-3.7c-0.3-1.4-0.9-2.2-2-3.8c2.2-1.6,2.7-4.2,2.3-5.9
	c-0.3-1.1-1.1-1.9-1.5-3s-0.7-2.5,0.9-4.4c2.1-2.4,2.8-0.9,6-2.9c2-1.3,2.8-1.8,3-3.9C234.6,131,232.6,128,232,126.6z M141.1,151.3
	c0,0-3-5-9.3-9.1c-2.5-1.6-13.8-10.2-16.4-13.1c-3.5-3.8-8.3-11.1-9.4-14.8c-1.1-3.6-1.5-10.8,0-14.6c1.4-3.5,5.1-6.7,6.5-7.5
	c1.8-1.1,5.7-2.5,10-2.1c5.2,0.5,8.7,3.6,10,6.2c2.2,4.5,2.6,9.2,1.2,14c-0.8,2.6-4,7.4-4.5,9.8c-0.5,2.4,2.8,5.3,2.8,5.3
	s-3.3,0.7-5.2-0.3c-1.9-1-2.5-4.3-1.9-6.5c1-3.9,2.9-4.7,4.3-10c0.7-2.6-0.9-8.3-2.1-10.6s-5.5-3.9-7.6-3.9c-2.1,0-6.6,1.4-8.6,3.9
	c-1.6,2-3.6,9.3-2.8,13.4c1,3.4,3.9,9.2,5.2,11c1.4,1.9,2.8,3.9,5.3,6.5c2.2,2.3,14.6,10.9,15.6,11.6c1,0.7,6,4,6.9,6.2
	C142,148.9,141.1,151.3,141.1,151.3z M210.9,98.8c-1.2,2.7-7.8,3.4-9.1,5.4c-0.9,1.3,1.2,4.5,2.5,5c2.2,1,4,1.3,4,1.3l-0.5,6.4
	c0,0-3.5-5.4-7.9-8.1c-3.3-2-6.4-1.9-10.2-1.3c-3.8,0.6-11.4-0.3-15,0.9c-3.6,1.1-6.7,4.9-7.6,7.1c-1.3,3.2,0.9-4.9,0.9-4.9
	s1.2-2.5,3.4-3.4c5.5-2.4,10.4-1.7,14-1.9s11.9-3.5,14.4-4.7c3.7-1.9,11-5.9,11.2-6.4S211.7,96.8,210.9,98.8z"
    />
  </svg>
);

export default SVG;
